/** DeepThink's WhatsApp chat, for links that open it directly. */
export const DEEPTHINK_WHATSAPP_URL = 'https://wa.me/6580127012';
